import { FrontendPlatform, FrontendPlatformContext, kosmodSite } from "@kosmod/core";
import { Component, h, useMemo } from "@lukekaalim/act";
import { AuthenticatePage, GameID, InvitationID, InvitationPage, SesameHome, useAuthStateProvider } from "@kosmod/sesame";
import { HttpApi } from "@kosmod/pancake";

import { kosmodAPI, TabletopConfig } from "../defs";
import { LoggerContext, ModalRenderer, useModalManagerProvider } from "@kosmod/kit";
import { useRootSiteManager } from "@kosmod/graphics-2d";
import { DemoPage, MyGames, RoomID, RoomPage } from "@kosmod/concierge";
import { FrontendServices, FrontendServicesContext } from "@kosmod/core";

import classes from './TabletopApp.module.css';
import { html } from "@lukekaalim/act-web";

export type TabletopAppProps = {
  platform: FrontendPlatform,
  config: TabletopConfig,
}

export const TabletopApp: Component<TabletopAppProps> = ({ platform, config }) => {
  const urls = useMemo(() => HttpApi.createURLMap(kosmodAPI, config.apiBaseURL), [config]);

  const authorizedHosts = useMemo(() => new Set([config.apiBaseURL.hostname]), [config.apiBaseURL.hostname]);

  const auth = useAuthStateProvider(platform.net, urls.login, platform.storage, authorizedHosts);
  const modal = useModalManagerProvider();
  const site = useRootSiteManager(kosmodSite, platform.router);

  const api = useMemo(() =>
    HttpApi.createClientFromURLMap(kosmodAPI, urls, auth.net),
    [urls, auth.net]
  );

  const services = useMemo((): FrontendServices => {
    return {
      site,
      modal,
    }
  }, [site, modal])

  return h(html.section, { className: classes.app },
    h(FrontendPlatformContext.Provider, { value: platform },
      h(FrontendServicesContext.Provider, { value: services }, 
        h(LoggerContext.Provider, { value: platform.logger }, [
        site.pages.map(page => { 
          switch (page.path) {
            case '/games':
              return h(MyGames, { clients: { concierge: api.session, games: api.games }, auth })
            case '/login':
              return h(AuthenticatePage, { mode: 'login', auth });
            case '/sign-up':
              return h(AuthenticatePage, { mode: 'sign-up', auth });
            case '/':
              return h(SesameHome, { auth })
            case '/room':
              if (!page.query || !page.query.room)
                return 'WHERES THE PAGE BOB';
        
              return h(RoomPage, { roomId: page.query.room as RoomID, gameId: page.query.game as GameID, clients: {
                theatre: api.scene,
                concierge: api.session,
                games: api.games,
                auth: auth,
                assets: api.assets,
                net: auth.net,
              }, urls, config })
            case '/demo':
              return h(DemoPage, {
                clients: {
                  theatre: api.scene,
                  sesame: api.login,
                  concierge: api.session,
                }
              })
            case '/invitation':
              return h(InvitationPage, {
                clients: {
                  auth,
                  games: api.games,
                },
                invitationId: page.query.id as InvitationID,
                invitationSecret: page.query.code,
              })
            default:
              return 'NOT YET SUPPORTED'
          }
      }),
      h(ModalRenderer, { manager: modal }),
    ])))
  );
};
